import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex max-h-[92vh] w-full max-w-lg flex-col overflow-hidden rounded-2xl bg-white shadow-2xl" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-1 flex-col items-center justify-center p-10"
}
const _hoisted_3 = {
  key: 1,
  class: "p-6 text-center text-red-600"
}
const _hoisted_4 = {
  key: 2,
  class: "flex-1 overflow-y-auto p-4 sm:p-5"
}
const _hoisted_5 = {
  key: 0,
  class: "space-y-4 rounded-xl border-2 border-amber-200 bg-gradient-to-br from-amber-50 to-orange-50 p-4"
}
const _hoisted_6 = {
  key: 0,
  class: "mt-1 text-xs text-red-600"
}
const _hoisted_7 = {
  key: 0,
  class: "mt-1 text-xs text-red-600"
}
const _hoisted_8 = {
  key: 0,
  class: "mt-1 text-xs text-red-600"
}
const _hoisted_9 = {
  key: 1,
  class: "mt-3 flex flex-wrap items-end gap-3"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "flex flex-col gap-2 border-t border-slate-200 bg-slate-50 px-4 py-3 sm:flex-row sm:justify-end sm:gap-3 sm:px-5" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]

import { ref, watch, computed } from "vue";
import { useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/yup";
import * as yup from "yup";
import { useProductoFindOne } from "../../composables/productoComposables";


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalPromocionProducto',
  props: {
    open: { type: Boolean },
    productoId: {},
    isSaving: { type: Boolean }
  },
  emits: ["close", "update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const imagenPromocion = ref<File | null>(null);
const imagenPromocionPreview = ref("");
const promoBannerUrlGuardada = ref("");
const errorImagenPromocion = ref("");

/** Copia del producto para armar el PUT completo */
const productoBase = ref<Record<string, unknown> | null>(null);
const archivosExistentesIds = ref<string[]>([]);
const especificaciones = ref<{ nombreEspTecnicas: string; detallesEspTecncias: string }[]>(
  []
);
const modelosCompatibles = ref<string[]>([]);

const promoSchema = toTypedSchema(
  yup.object({
    isPromocion: yup.number().oneOf([0, 1]).optional(),
    promocionTitulo: yup.string().when("isPromocion", {
      is: (v: unknown) => Number(v) === 1,
      then: (schema) =>
        schema
          .transform((val) => (typeof val === "string" ? val.trim() : val ?? ""))
          .required("El título del banner es obligatorio")
          .min(3, "Mínimo 3 caracteres")
          .max(160),
      otherwise: (schema) => schema.optional(),
    }),
    promocionSubtitulo: yup.string().when("isPromocion", {
      is: (v: unknown) => Number(v) === 1,
      then: (schema) =>
        schema
          .transform((val) => (typeof val === "string" ? val.trim() : val ?? ""))
          .required("El subtítulo del banner es obligatorio")
          .min(3, "Mínimo 3 caracteres")
          .max(240),
      otherwise: (schema) => schema.optional(),
    }),
    promocionCtaTexto: yup.string().when("isPromocion", {
      is: (v: unknown) => Number(v) === 1,
      then: (schema) =>
        schema
          .transform((val) => (typeof val === "string" ? val.trim() : val ?? ""))
          .max(80, "Máximo 80 caracteres")
          .optional(),
      otherwise: (schema) => schema.optional(),
    }),
  })
);

const {
  errors,
  meta,
  handleSubmit,
  resetForm,
  setValues,
  setFieldTouched,
  validateField,
  defineField,
} = useForm({
  validationSchema: promoSchema,
  initialValues: {
    isPromocion: 0,
    promocionTitulo: "",
    promocionSubtitulo: "",
    promocionCtaTexto: "Ver oferta",
  },
});

const [isPromocion] = defineField("isPromocion");
const [promocionTitulo] = defineField("promocionTitulo");
const [promocionSubtitulo] = defineField("promocionSubtitulo");
const [promocionCtaTexto] = defineField("promocionCtaTexto");

const productoIdRef = computed(() => props.productoId || "");
const { data: productoData, isPending, isError, refetch } = useProductoFindOne(
  productoIdRef
);

const promocionImagenOk = computed(() => {
  if (Number(isPromocion.value) !== 1) return true;
  return !!(imagenPromocion.value || imagenPromocionPreview.value);
});

const puedeGuardar = computed(
  () => meta.value.valid && promocionImagenOk.value && !errorImagenPromocion.value
);

function mapProductoFromResponse(raw: unknown) {
  const root = raw as { data?: { data?: Record<string, unknown> } };
  return root?.data?.data ?? null;
}

watch(
  () => [props.open, props.productoId] as const,
  ([open, id]) => {
    if (open && id) {
      void refetch();
    }
  }
);

watch(productoData, (newData) => {
  if (!props.open || !props.productoId) return;
  const producto = mapProductoFromResponse(newData);
  if (!producto || String(producto.id) !== String(props.productoId)) return;
  if (!producto) return;

  productoBase.value = producto;
  setValues({
    isPromocion: (producto.isPromocion as number) ?? 0,
    promocionTitulo: (producto.promocionTitulo as string) ?? "",
    promocionSubtitulo: (producto.promocionSubtitulo as string) ?? "",
    promocionCtaTexto: (producto.promocionCtaTexto as string) || "Ver oferta",
  });

  imagenPromocion.value = null;
  const ap = producto.archivoPromocion as { url?: string } | null | undefined;
  const urlPromo = ap?.url?.trim() ?? "";
  promoBannerUrlGuardada.value = urlPromo;
  imagenPromocionPreview.value = urlPromo;
  errorImagenPromocion.value = "";

  especificaciones.value =
    (producto.GpEspTecnicasProducto as any[])?.map((esp) => ({
      nombreEspTecnicas: esp.especificacion?.nombreEspTecnicas || "",
      detallesEspTecncias: esp.especificacion?.detallesEspTecncias || "",
    })) || [];

  modelosCompatibles.value =
    (producto.GpModeloVehiculoProducto as any[])
      ?.map((mv) => mv.modeloVehiculo?.id || "")
      .filter(Boolean) || [];

  const gaps = producto.GpArchivosProducto as any[] | undefined;
  if (gaps?.length) {
    archivosExistentesIds.value = gaps
      .map((arch: { idArchivo?: string; archivo?: { id?: string } }) =>
        arch.idArchivo ?? arch.archivo?.id ?? ""
      )
      .filter(Boolean);
  } else {
    archivosExistentesIds.value = [];
  }
});

watch([imagenPromocion, imagenPromocionPreview, isPromocion], () => {
  if (promocionImagenOk.value) errorImagenPromocion.value = "";
});

watch(isPromocion, (v) => {
  if (Number(v) !== 1) errorImagenPromocion.value = "";
});

function buildFormData(values: {
  isPromocion?: number;
  promocionTitulo?: string;
  promocionSubtitulo?: string;
  promocionCtaTexto?: string;
}): FormData | null {
  const p = productoBase.value;
  if (!p || !props.productoId) return null;

  const formData = new FormData();
  formData.append("nombreProducto", String(p.nombreProducto ?? "").trim());
  formData.append(
    "descripcionProducto",
    String(p.descripcionProducto ?? "").trim()
  );
  formData.append("idMarca", String(p.idMarca ?? ""));
  formData.append("idCategoria", String(p.idCategoria ?? ""));
  formData.append("precioProducto", String(p.precioProducto ?? 0));
  formData.append("stockProducto", String(p.stockProducto ?? 0));
  formData.append("isDestacado", String(p.isDestacado ?? 0));
  formData.append("isPromocion", String(values.isPromocion ?? 0));

  if (Number(values.isPromocion) === 1) {
    formData.append("promocionTitulo", String(values.promocionTitulo ?? "").trim());
    formData.append(
      "promocionSubtitulo",
      String(values.promocionSubtitulo ?? "").trim()
    );
    const cta = String(values.promocionCtaTexto ?? "").trim() || "Ver oferta";
    formData.append("promocionCtaTexto", cta);
    if (imagenPromocion.value) {
      formData.append("imagenPromocion", imagenPromocion.value);
    }
  }

  formData.append(
    "especificaciones",
    JSON.stringify(
      especificaciones.value.filter(
        (e) => e.nombreEspTecnicas.trim() && e.detallesEspTecncias.trim()
      )
    )
  );
  formData.append("modelosCompatibles", JSON.stringify(modelosCompatibles.value));
  formData.append("archivosExistentes", JSON.stringify(archivosExistentesIds.value));

  return formData;
}

const submit = handleSubmit((values) => {
  if (Number(values.isPromocion) === 1) {
    const ok =
      !!imagenPromocion.value ||
      !!(promoBannerUrlGuardada.value || imagenPromocionPreview.value);
    if (!ok) {
      errorImagenPromocion.value =
        "Debe subir una imagen ancha para el banner (PNG, JPG, WEBP, máx. 8MB)";
      return;
    }
  }
  errorImagenPromocion.value = "";

  const fd = buildFormData(values);
  if (fd && props.productoId) {
    emit("update", props.productoId, fd);
  }
});

async function guardar() {
  await setFieldTouched("isPromocion", true);
  await setFieldTouched("promocionTitulo", true);
  await setFieldTouched("promocionSubtitulo", true);
  await setFieldTouched("promocionCtaTexto", true);
  submit();
}

function desactivarPromocion() {
  if (!productoBase.value || !props.productoId) return;
  const fd = buildFormData({ isPromocion: 0 });
  if (fd) emit("update", props.productoId, fd);
}

function cerrar() {
  resetForm();
  imagenPromocion.value = null;
  imagenPromocionPreview.value = "";
  promoBannerUrlGuardada.value = "";
  productoBase.value = null;
  errorImagenPromocion.value = "";
  emit("close");
}

const togglePromocion = () => {
  isPromocion.value = Number(isPromocion.value) === 1 ? 0 : 1;
  setFieldTouched("isPromocion", true);
  void validateField("isPromocion");
};

const onPromoImageChange = (e: Event) => {
  const input = e.target as HTMLInputElement;
  const file = input.files?.[0];
  input.value = "";
  if (!file) return;
  imagenPromocion.value = file;
  imagenPromocionPreview.value = URL.createObjectURL(file);
};

const quitarImagenPromocion = () => {
  imagenPromocion.value = null;
  imagenPromocionPreview.value = promoBannerUrlGuardada.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (__props.open)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-3 backdrop-blur-sm sm:p-4",
            onClick: _withModifiers(cerrar, ["self"])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", { class: "flex items-center justify-between border-b border-amber-100 bg-gradient-to-r from-amber-500 to-orange-500 px-4 py-3 sm:px-5" }, [
                _cache[6] || (_cache[6] = _createElementVNode("div", null, [
                  _createElementVNode("p", { class: "text-xs font-bold uppercase tracking-wide text-white/90" }, " Inicio "),
                  _createElementVNode("h2", { class: "text-lg font-bold text-white sm:text-xl" }, " Carrusel de promoción ")
                ], -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "rounded-lg p-2 text-white transition hover:bg-white/20",
                  "aria-label": "Cerrar",
                  onClick: cerrar
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("svg", {
                    class: "h-5 w-5",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))])
              ]),
              (_unref(isPending))
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("div", { class: "h-10 w-10 animate-spin rounded-full border-2 border-amber-500 border-t-transparent" }, null, -1),
                    _createElementVNode("p", { class: "mt-3 text-sm text-slate-600" }, "Cargando producto…", -1)
                  ]))]))
                : (_unref(isError))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, " No se pudo cargar el producto. "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _cache[14] || (_cache[14] = _createElementVNode("p", { class: "mb-4 text-sm text-slate-600" }, " Si activa esta opción, el producto puede mostrarse en el carrusel ancho del inicio de la tienda. Debe indicar textos del banner y una imagen horizontal. ", -1)),
                      _createElementVNode("button", {
                        type: "button",
                        class: "mb-5 flex w-full items-center gap-3 rounded-lg text-left transition hover:bg-amber-50",
                        onClick: togglePromocion
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["relative inline-flex h-6 w-11 shrink-0 items-center rounded-full bg-slate-300 transition", Number(_unref(isPromocion)) === 1 ? 'bg-amber-500' : ''])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["inline-block h-5 w-5 translate-x-1 transform rounded-full bg-white shadow transition", Number(_unref(isPromocion)) === 1 ? 'translate-x-5' : ''])
                          }, null, 2)
                        ], 2),
                        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-sm font-medium text-slate-800" }, "Producto en promoción (inicio)", -1))
                      ]),
                      (Number(_unref(isPromocion)) === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("div", null, [
                              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "mb-1 block text-sm font-semibold text-slate-700" }, [
                                _createTextVNode(" Título del banner "),
                                _createElementVNode("span", { class: "text-red-500" }, "*")
                              ], -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(promocionTitulo) ? (promocionTitulo).value = $event : null)),
                                class: "w-full rounded-lg border-2 border-slate-200 px-3 py-2 text-sm focus:border-amber-500 focus:outline-none",
                                placeholder: "Ej: PORTAEQUIPAJES UNIVERSAL",
                                onBlur: _cache[1] || (_cache[1] = ($event: any) => {
                  _unref(setFieldTouched)('promocionTitulo', true);
                  _unref(validateField)('promocionTitulo');
                })
                              }, null, 544), [
                                [_vModelText, _unref(promocionTitulo)]
                              ]),
                              (_unref(errors).promocionTitulo)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_unref(errors).promocionTitulo), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "mb-1 block text-sm font-semibold text-slate-700" }, [
                                _createTextVNode(" Subtítulo del banner "),
                                _createElementVNode("span", { class: "text-red-500" }, "*")
                              ], -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(promocionSubtitulo) ? (promocionSubtitulo).value = $event : null)),
                                class: "w-full rounded-lg border-2 border-slate-200 px-3 py-2 text-sm focus:border-amber-500 focus:outline-none",
                                placeholder: "Texto secundario (más corto que el título)",
                                onBlur: _cache[3] || (_cache[3] = ($event: any) => {
                  _unref(setFieldTouched)('promocionSubtitulo', true);
                  _unref(validateField)('promocionSubtitulo');
                })
                              }, null, 544), [
                                [_vModelText, _unref(promocionSubtitulo)]
                              ]),
                              (_unref(errors).promocionSubtitulo)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(errors).promocionSubtitulo), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "mb-1 block text-sm font-semibold text-slate-700" }, " Texto del botón (CTA) ", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(promocionCtaTexto) ? (promocionCtaTexto).value = $event : null)),
                                class: "w-full rounded-lg border-2 border-slate-200 px-3 py-2 text-sm focus:border-amber-500 focus:outline-none",
                                placeholder: "Ver oferta"
                              }, null, 512), [
                                [_vModelText, _unref(promocionCtaTexto)]
                              ])
                            ]),
                            _createElementVNode("div", null, [
                              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "mb-1 block text-sm font-semibold text-slate-700" }, [
                                _createTextVNode(" Imagen ancha del banner "),
                                _createElementVNode("span", { class: "text-red-500" }, "*")
                              ], -1)),
                              _createElementVNode("input", {
                                type: "file",
                                accept: "image/jpeg,image/png,image/gif,image/webp",
                                class: "block w-full text-sm text-slate-600 file:mr-3 file:rounded-lg file:border-0 file:bg-amber-600 file:px-4 file:py-2 file:font-semibold file:text-white",
                                onChange: onPromoImageChange
                              }, null, 32),
                              _cache[13] || (_cache[13] = _createElementVNode("p", { class: "mt-1 text-xs text-slate-500" }, " Recomendado formato horizontal (p. ej. 1600×600). Máx. 8 MB. ", -1)),
                              (errorImagenPromocion.value)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(errorImagenPromocion.value), 1))
                                : _createCommentVNode("", true),
                              (imagenPromocionPreview.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _createElementVNode("img", {
                                      src: imagenPromocionPreview.value,
                                      alt: "Vista previa banner",
                                      class: "max-h-36 max-w-full rounded-lg border object-cover shadow"
                                    }, null, 8, _hoisted_10),
                                    (imagenPromocion.value)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "rounded-lg border border-slate-300 px-3 py-1.5 text-sm text-slate-700 hover:bg-slate-100",
                                          onClick: quitarImagenPromocion
                                        }, " Quitar imagen nueva "))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])),
              _createElementVNode("div", _hoisted_11, [
                ((productoBase.value?.isPromocion as number) === 1)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "order-2 w-full rounded-lg border border-red-200 px-4 py-2.5 text-sm font-semibold text-red-700 transition hover:bg-red-50 sm:order-1 sm:w-auto",
                      disabled: props.isSaving,
                      onClick: desactivarPromocion
                    }, " Desactivar promoción ", 8, _hoisted_12))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "order-3 w-full rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 sm:order-2 sm:w-auto",
                  onClick: cerrar
                }, " Cancelar "),
                _createElementVNode("button", {
                  type: "button",
                  class: "order-1 w-full rounded-lg bg-amber-600 px-4 py-2.5 text-sm font-semibold text-white shadow hover:bg-amber-700 disabled:opacity-50 sm:order-3 sm:w-auto",
                  disabled: !puedeGuardar.value || _unref(isPending) || props.isSaving,
                  onClick: guardar
                }, _toDisplayString(props.isSaving ? "Guardando…" : "Guardar"), 9, _hoisted_13)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})